import { memo } from 'react';
import styled, { css } from 'styled-components';
import { spacing, typography, colors, borderRadius, elevation, size } from '@izettle/otto';
import { ZINDEX_SELECT_LIST, FOCUS_BORDER_WIDTH, ZINDEX_SELECT_LIST_FULLSCREEN } from '../helpers/constants.js';

const mixinIsExpanded = css`
  ${_ref => {
  let {
    isExpanded
  } = _ref;
  return isExpanded ? `
      opacity: 1;
    ` : `
      opacity: 0;
      transform: translateY(${spacing.xxSmall});
      pointer-events: none;
    `;
}}
`;
const SelectListPlacement = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__SelectListPlacement",
  componentId: "zettle__sc-ilte6k-0"
})(["position:relative;width:100%;z-index:", ";"], ZINDEX_SELECT_LIST));

/* Here z-index is set to 20, to be above the FloatingLabels of adjacent components */
const SelectListContainer = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__SelectListContainer",
  componentId: "zettle__sc-ilte6k-1"
})(["", " margin:0;max-width:100%;max-height:300px;overflow-y:scroll;background:", ";cursor:pointer;display:flex;flex-direction:column;padding:", " 0;border-radius:", ";box-shadow:", ";transition:opacity 0.2s,transform 0.2s;min-height:", ";position:absolute;width:calc(100% + ", " * 2);", " ", " ", ""], typography.regular, colors.background.default, spacing.xSmall, borderRadius.large, elevation.level3, size.large, FOCUS_BORDER_WIDTH, mixinIsExpanded, _ref2 => {
  let {
    isLoading
  } = _ref2;
  return isLoading && `
      cursor: progress;
    `;
}, _ref3 => {
  let {
    hasActions
  } = _ref3;
  return hasActions && `
      padding-bottom: 0;
    `;
}));
const SelectListMobile = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__SelectListMobile",
  componentId: "zettle__sc-ilte6k-2"
})(["position:fixed;margin:0;top:0;bottom:0;left:0;right:0;background:", ";transition:opacity 0.2s,transform 0.2s;display:flex;flex-direction:column;padding:", " 0 0 0;z-index:", ";align-self:flex-end;", ""], colors.background.default, spacing.xSmall, ZINDEX_SELECT_LIST_FULLSCREEN, mixinIsExpanded));
const SelectListContent = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__SelectListContent",
  componentId: "zettle__sc-ilte6k-3"
})(["height:100%;display:flex;flex:1;flex-direction:column;justify-content:space-between;overflow:hidden;"]));
const ChildrenContainer = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__ChildrenContainer",
  componentId: "zettle__sc-ilte6k-4"
})(["overflow-y:scroll;width:100%;display:flex;flex:1;flex-direction:column;"]));
const ButtonContainer = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__ButtonContainer",
  componentId: "zettle__sc-ilte6k-5"
})(["box-sizing:border-box;padding:", ";width:100%;align-self:flex-end;max-height:fit-content;display:flex;flex-direction:column;"], spacing.xSmall));
const LabelContainer = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__LabelContainer",
  componentId: "zettle__sc-ilte6k-6"
})(["padding:", ";text-overflow:ellipsis;overflow:hidden;", ""], spacing.xSmall, typography.title2));
const FocusTrap = /*#__PURE__*/memo(styled.button.withConfig({
  displayName: "styles__FocusTrap",
  componentId: "zettle__sc-ilte6k-7"
})(["max-width:0;max-height:0;opacity:0;"]));

export { ButtonContainer, ChildrenContainer, FocusTrap, LabelContainer, SelectListContainer, SelectListContent, SelectListMobile, SelectListPlacement };
//# sourceMappingURL=styles.js.map
